import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const SalesReturnInwardConsignment = () => (
  <SectionIncomingConsignment
    sectionName="Sales Return"
    sectionDisplayName="Sales Return Section"
    backRoute="/sections/sales-return"
  />
);

export default SalesReturnInwardConsignment;
